import { apiAdminViewsFetch } from '..';
import type { MoveEntityInvestmentBoardEntryPayload } from './types';

/**
 * `investmentMoveData` is included only when present — the backend rejects the
 * key on every stage other than `Invested`.
 */
export const _moveEntityInvestmentBoardEntry = ({
  entryId,
  targetStage,
  note,
  investmentMoveData,
}: MoveEntityInvestmentBoardEntryPayload) =>
  apiAdminViewsFetch<{ success: boolean }>(`/entity-investment-board/entries/${entryId}/move`, {
    method: 'PATCH',
    body: {
      targetStage,
      ...(note === undefined || note === null ? {} : { note }),
      ...(investmentMoveData === undefined ? {} : { investmentMoveData }),
    },
  });
